import React from 'react';
import '../../resources/styles.scss';


export default class ToggleButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { checked: this.props.value ? this.props.value : this.props.defaultValue, defaultChecked: this.props.defaultValue };
        this.toggleChecked = this.toggleChecked.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (state.defaultChecked !== undefined && props.defaultValue !== state.defaultChecked) {
            return {
                checked: props.defaultValue,
                defaultChecked: props.defaultValue
            }
        }

        if (props.value === undefined) {
            return null;
        }

        return {
            checked: props.value,
            defaultChecked: props.defaultValue
        }
    }

    toggleChecked() {
        const checked = !this.state.checked;
        this.setState({ ...this.state, checked: checked });
        if (typeof this.props.onChange === "function") {
            this.props.onChange(checked);
        }
    }

    render() {
        let checked = this.state.checked;
        return (
            <label className="switch" disabled={this.props.disabled}>
                <input type="checkbox" checked={checked} onChange={this.toggleChecked}/>
                <span className="slider round"></span>
            </label>
        );
    }
}